import store from "../store";

export default async function is_admin({ next, router }) {
    await store.dispatch('profile/role');
    let role = await store.getters['profile/role'];
    if (role !== 'admin') {
        return router.push({ name: "User Profile" });
    }

    return next();
}
